/* eslint-disable global-require */
const format = require('date-fns/format');

const locales = {
    en: require('date-fns/locale/en'),
    nl: require('date-fns/locale/nl'),
};

export default function(date, formatStr) {
    if (!window.appLocale) {
        console.error("Date Format Module won't work without a global appLocale defined");
    }

    const localeObj = (locales[window.appLocale]) ? locales[window.appLocale] : locales.en;

    return format(date, formatStr, {
        locale: localeObj,
    });
}
